import index from "./auditLicenseRequest.vue";
export default index;
